import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_light_component = _resolveComponent("light-component")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createElementBlock("div", { style: {"max-width":"45rem"} }, [
    _createElementVNode("div", { style: {"display":"grid","grid-template-columns":"repeat(6, 1fr)","grid-template-rows":"1fr"} }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.lights, (light) => {
        return (_openBlock(), _createBlock(_component_light_component, {
          id: light.id
        }, null, 8 /* PROPS */, ["id"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.buttons, (button) => {
      return (_openBlock(), _createBlock(_component_button_component, {
        id: button.id
      }, null, 8 /* PROPS */, ["id"]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}